"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function exists(value) {
    return value !== undefined && value !== null;
}
exports.default = exists;
